import styleInject from '../../../common/temp/pnpm_store/.pnpm/style-inject@0.3.0/pnpm_store/style-inject/dist/style-inject.es.js';

var css_248z = ".slider_dragger__2Q48r {\n  cursor: pointer;\n  width: 10px;\n  height: 10px;\n}\n.slider_clipable__1ljDw {\n  overflow: hidden;\n  display: inline-block;\n  width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.slider_slider__DsC_x {\n  color: var(--workbench-theme-toolbar-text-color);\n}\n";
var styles = {"dragger":"slider_dragger__2Q48r","clipable":"slider_clipable__1ljDw","slider":"slider_slider__DsC_x"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=slider.less.js.map
